import React from 'react'

function Title() {
  return (
    <div className='title'>
      <h2>Fresh from Pizzon</h2>
      <h1>Our Special Menu</h1>
    </div>
  )
}

export default Title
